import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload-date'

const BlokajSevkYeriExcel = () => {
    return (
        <>
            <ExcelUpload
                role_name={"blokaj_sevk_write"}
                requiredColumnsSase={[
                    "Tarih",
                    "sase",
                    "Talep Eden Bayi",
                    "Sevk/Blokaj Bilgisi",
                    "Sevk Istenen Adres",
                    "Sevk Il"
                ]}
                process_type="BLOCKING_SHIPPING"
                ExcelName={"Hatalı Blokaj/Sevk Verileri"}
                Title={"Blokaj/Sevk Yeri"}
                exampleData={[
                    {
                        "Tarih": "01.01.2025",
                        "sase": "VR3USHNS7RJ793212",
                        "Talep Eden Bayi": "AĞAÇLI",
                        "Sevk/Blokaj Bilgisi": "BLOKAJ",
                        "Sevk Istenen Adres": "",
                        "Sevk Il": ""
                    },
                    {
                        "Tarih": "01.01.2025",
                        "sase": "VR3USHNS7RJ793212",
                        "Talep Eden Bayi": "AĞAÇLI",
                        "Sevk/Blokaj Bilgisi": "SEVK",
                        "Sevk Istenen Adres": "AĞAÇLI",
                        "Sevk Il": "İSTANBUL"
                    }
                ]}
            />
        </>
    )
}

export default BlokajSevkYeriExcel